 import { styled } from "@mui/material/styles";

const StyledLinkExpired = styled("div")(
  ({ theme }) => `
  .linkExpired-wrap {
  width: 27%;
  margin: 20px auto;
  padding: 30px 0;
  text-align: center;
   display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
  }
}
.circleIcon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #B602181A;
  display: flex;
  justify-content: center;
  align-items: center;
}
.linkExpired-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: 100%;
}
.body-text {
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 22px;
}
.resend-link-btn {
  width: 100%;
}  
.custom-button {
  font-family: Lexend;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  text-transform: none;
  padding: 10px 20px;
  border-radius: 0px;
  width: 100%;
  height: 40px;
}
.body-text-2 {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 22px;
}  
.body-text-2 span {
  color: ${theme.palette.customColor.secondarySecond};
}  
.backLogin {
  text-align: center;
}
.backLogin a {
  font-family: Lexend;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: ${theme.palette.primary.main};
  text-decoration: underline
  cursor: pointer;
}
          
  `
);

export default StyledLinkExpired;
